export function getBackground(...params) {
  return params.filter(param => !!param).join(',');
}
